export default "__VITE_PUBLIC_ASSET__7c76be9d__"